import styled from 'styled-components';

export const HeaderContainer = styled.header`
 max-width: 960px;
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 36px;
 padding-bottom: 16px;
 padding-top: 16px;
 border-bottom: 1px solid #2a363b;

 @media screen and (max-width: 480px) {
   max-width: 360px;
  }
  @media screen and (max-width: 780px) {
   max-width: 680px;
  }
 `;

 
